module.exports = __webpack_public_path__ + "media/components/country-flag/static/fj-784b9f649b4cb6b9876beaef00e0815a.svg";